/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/TriPeaksTemplate/TriPeaksInputInterpreter',[
        'absolute/debug',
        'Arkadium/GameEngine/Core/EngineManagers',
        'SolitaireShared/CardLogic/CardAction',
        'SolitaireShared/CardLogic/CardOp'
    ],
    function (Debug, EngineManagers, CardAction, CardOp) {
        "use strict";

        var TriPeaksInputInterpreter = function (authority) {
            this.initTriPeaksInputInterpreter(authority);
        };

        TriPeaksInputInterpreter.prototype.initTriPeaksInputInterpreter = function (authority) {
            this.Authority = authority;

            this.IsClickedOnCard = false;
            this.InputEnabled = true;

            this.HighlightedCard = null;
            this.HighlightTime = -1;
        };


        TriPeaksInputInterpreter.prototype.NotifyCardsMoved = function () {
            this.ClearHighlight();
        };


        TriPeaksInputInterpreter.prototype.Drag = function (cardDragged, distance) {
            return true;
        };

        TriPeaksInputInterpreter.prototype.Drop = function (cardDropped, dropPiles) {
            var supply = cardDropped.Card.Supply;
            var action = new CardAction(supply);
            action.Parse(["noop"]);
            return action;
        };

        TriPeaksInputInterpreter.prototype.ClickCard = function (cardClicked, rightClicked) {
            var supply = cardClicked.Card.Supply;
            var action = new CardAction(supply);
            action.Parse(["noop"]);
            if (rightClicked) {
                // do nothing on a right click
                return action;
            }

            if (!this.InputEnabled) return action;

            if (cardClicked.Card.Pile.Type == "Stock") {
                action.Parse(["move", cardClicked.Card.Pile.Name, "Waste", "1"]);
                this.Authority.CardSupply.OnFlipCard();
            }
            else if (cardClicked.Card.Pile.Type == "Tableau") {
                if (!cardClicked.Card.Pile.Empty) {
                    var tableaus = this.Authority.GetTableausRevealedByRemoving(cardClicked.Card.Pile);
                    if (tableaus.length == 0) {
                        action.Parse(["move", cardClicked.Card.Pile.Name, "Waste", "1"]);
                    }
                    else if (tableaus.length == 1) {
                        var faceDown = this.Authority.GetFaceDownForTableau(tableaus[0]);
                        action.Parse(["begin",
                            "move", cardClicked.Card.Pile.Name, "Waste", "1",
                            "move", faceDown.Name, tableaus[0].Name, "1",
                            "end"]);
                        this.Authority.CardSupply.OnFlipCard(/* TODO new EventArgs() */);

                    }
                    else if (tableaus.length == 2) {
                        var faceDown = this.Authority.GetFaceDownForTableau(tableaus[0]);
                        var faceDown2 = this.Authority.GetFaceDownForTableau(tableaus[1]);
                        action.Parse(["begin",
                            "move", cardClicked.Card.Pile.Name, "Waste", "1",
                            "move", faceDown.Name, tableaus[0].Name, "1",
                            "move", faceDown2.Name, tableaus[1].Name, "1",
                            "end"]);
                        this.Authority.CardSupply.OnFlipCard(/* TODO new EventArgs() */);

                    }

//#if WIN8
                    if (action.IsAllowed()) {
                        EngineManagers.Sounds.PlaySound("flipCardOffScreen");
                    }
//#endif
                }
            }
            else if (cardClicked.Card.Pile.Type == "Joker") {
                EngineManagers.Sounds.PlaySound("wildCard");
                action.Parse(["move", cardClicked.Card.Pile.Name, "Waste", "1"]);
                this.Authority.CardSupply.OnFlipCard(/* TODO new EventArgs() */);
            }
            return action;
        };

        TriPeaksInputInterpreter.prototype.ClickEmptyPile = function (pileClicked) {
            var supply = pileClicked.Pile.Supply;
            var action = new CardAction(supply);
            action.Parse(["noop"]);

            if (!this.InputEnabled) return action;

            if (pileClicked.Pile.Type == "Stock") {
                // don't deal when you click the empty pile, instead, deal when you click the button
                //Authority.Deal(); // TODO make sure it plays the sound
            }

            return action;
        };

        TriPeaksInputInterpreter.prototype.ClickOutside = function () {
        };


        TriPeaksInputInterpreter.prototype.IsCardHighlighted = function () {
            return (this.HighlightedCard != null);
        };

        TriPeaksInputInterpreter.prototype.GetHighlightedCard = function () {
            return this.HighlightedCard;
        };

        TriPeaksInputInterpreter.prototype.HighlightCard = function (card) {
            this.HighlightedCard = card;
            this.HighlightedCard.Highlight();
            this.HighlightTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
            Debug.log("HighlightCard " + card.Card);
            // notify UI?
        };

        TriPeaksInputInterpreter.prototype.ClearHighlight = function () {
            if (this.HighlightedCard != null) {
                this.HighlightedCard.ClearHighlight();
                this.HighlightedCard = null;
                this.HighlightTime = -1;
            }
            Debug.log("ClearHighlight()");
            // notify UI?
        };

        TriPeaksInputInterpreter.prototype.ShouldMoveKeyboard = function (action, card) {
            if (!this.InputEnabled) return false;
            for (var i = 0; i < action.Ops.length; i++) {
                var op = action.Ops[i];
                if (op.Opcode == CardOp.Op.Move) {
                    var SourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
                    var DestPile = op.GetPile(CardOp.eMoveParams.DestPile);
                    if (SourcePile.Name != "Stock" && (SourcePile.Top == card || DestPile.Top == card))
                        return true;
                }
            }
            return false;
        };

        TriPeaksInputInterpreter.prototype.DealNextFromStock = function (supplyView) {
            var cardSupply = this.Authority.CardSupply;
            var action = new CardAction(cardSupply);
            if (!cardSupply.GetPile("Stock").Empty) {
                action.Parse(["begin", "move", "Stock", "Waste", "1", "end"]);
            }
            if (action.Run()) {
                EngineManagers.Sounds.PlaySound("singleCard");
            }
        };

        return TriPeaksInputInterpreter;

    });

